import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from '../icons'
import TestOpsGenieModal from './testOpsGenie.modal'
import { useUserSelector } from '../../store/selectors/userSelector'
import { trackEvent } from '../../_common/functions'

export default function TestOpsGenieButton() {
    const { t } = useTranslation()
    const user: any = useUserSelector()
    const [open, setOpen] = useState<boolean>(sessionStorage.getItem('testOpsGenieActive') === 'true' || false)
    const [init, setInit] = useState<boolean>(false)
    const [show, setShow] = useState(false)
    const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        sessionStorage.setItem('testOpsGenieActive', open.toString())
        if (open) {
            setInit(true)
        }
    }, [open])

    return (
        <div className="fixed bottom-9 right-20 z-50 flex flex-col items-end justify-end">
            {init && (
                <div className={open ? '' : 'w-0 h-0 hidden overflow-hidden'}>
                    <TestOpsGenieModal
                        onClose={() => {
                            setOpen(false)
                        }}
                    />
                </div>
            )}

            {show && (
                <div
                    className={`transition-all duration-300  origin-bottom-right
          ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-75 pointer-events-none'} bg-[#2F2F32] w-[13rem] leading-3 px-2 py-[0.417rem] rounded-[0.5rem] text-white text-[0.583rem]`}
                >
                    <p className="flex flex-col gap-1">
                        <span className="text-[0.7rem]">
                            {t('Hi')} {user.first_name}!
                        </span>
                        {/* <span>{t('Welcome to TestOps AI')}</span>  -- back*/}
                        <span>{t('I help you design experiments, analyze results, and turn insights into decisions. Ask your first question to get started.')}</span>
                    </p>
                </div>
            )}
            <button
                type="button"
                onClick={() => {
                    if (open) {
                        trackEvent('ai_assistant_closed', { source: 'footer_button' })
                    } else {
                        trackEvent('ai_assistant_opened', { source: 'footer_button' })
                    }
                    setOpen(!open)
                    setShow(false)
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current)
                        hoverTimeoutRef.current = null
                    }
                }}
                onMouseEnter={() => {
                    if (!open) {
                        hoverTimeoutRef.current = setTimeout(() => {
                            setShow(true)
                        }, 2500)
                    }
                }}
                onMouseLeave={() => {
                    if (hoverTimeoutRef.current) {
                        clearTimeout(hoverTimeoutRef.current)
                        hoverTimeoutRef.current = null
                    }
                    setShow(false)
                }}
                className="bg-gradient-to-b mt-2 from-[#E5B611] to-[#DBC848] text-white rounded-[0.625rem] shadow-1 relative transition h-10 w-10 flex justify-center items-center"
            >
                {/* <span className="absolute flex items-center justify-center bg-cyan-900 text-white text-[0.4rem] leading-none px-[0.2rem] py-[0.15rem] rounded-[3px] -top-[0.3rem] -right-1">{t('beta')}</span> */}
                <Icon name="MdOutlineKeyboardCommandKey" size={1.25} className="inline-block  text-black" />
            </button>
        </div>
    )
}
